module.exports = __webpack_public_path__ + "static/img/page_25.58bdc525.png";